import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import pure from 'recompose/pure';
import Typography from '@material-ui/core/Typography';
import WindowsIcon from '../images/windows.png';
import MacOSIcon from '../images/macOS.svg';
import AppleIcon from '../images/apple.png';
import Android from '../images/android.svg';
import Linux from '../images/linux.svg';
import OSIcon from '../images/os.png';

const sanitizeRestProps = ({
  addLabel,
  allowEmpty,
  basePath,
  cellClassName,
  className,
  formClassName,
  headerClassName,
  label,
  linkType,
  locale,
  record,
  resource,
  sortable,
  sortBy,
  source,
  textAlign,
  translateChoice,
  ...rest
}) => rest;

const OSField = ({
  className, source, record = {}, ...rest
}) => {
  // console.log('sdfsdf');
  let icon = OSIcon;
  switch (record.os) {
    case 'Windows':
      icon = WindowsIcon;
      break;
    case 'macOS':
      icon = MacOSIcon;
      break;
    case 'iOS':
      icon = AppleIcon;
      break;
    case 'Android':
      icon = Android;
      break;
    case 'Linux':
      icon = Linux;
      break;
    default:
      icon = OSIcon;
      break;
  }
  return (
    <Typography
      component="span"
      body1="body1"
      className={className}
      {...sanitizeRestProps(rest)}
    >
      <img width='14px' height='14px' src={icon} alt={get(record, 'os')} /> {get(record, source)}
    </Typography>
  );
};

OSField.propTypes = {
  addLabel: PropTypes.bool,
  basePath: PropTypes.string,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  sortBy: PropTypes.string,
  source: PropTypes.string.isRequired,
};

const PureTextField = pure(OSField);

PureTextField.defaultProps = {
  addLabel: true,
};

export default PureTextField;



// WEBPACK FOOTER //
// ./src/components/OSField.js